import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

// SelectableCell zeroes the cell's padding and pads its link 4px 18px instead, so the header and
// the no-permission cells pad the same way. Otherwise the header sits 10px left of the values.
const cellPadding = (theme) => theme.spacing(1, 4.5);

const styles = (theme) => ({
  // Reskin: the search results are the screen's highlight card.
  resultsContainer: reskinStyles(theme, theme.cardStyles.highlight),
  headerCell: {
    padding: cellPadding(theme),
    fontSize: 14,
    lineHeight: '20px'
  },
  cell: {
    padding: cellPadding(theme)
  },
  // One line per row: a long address is cut off here, with the full address as a tooltip.
  address: {
    display: 'block',
    maxWidth: 292,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  // Wraps between products and before the missing-price note, so a long row stays inside the
  // card; each product's icon, price and term stay together.
  offer: {
    display: 'inline-flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1, 2)
  },
  product: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    whiteSpace: 'nowrap'
  },
  productIcon: {
    width: 32,
    height: 32
  },
  plus: {
    marginRight: theme.spacing(1),
    fontSize: 14,
    color: theme.colors.text_secondary
  },
  price: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2
  },
  term: {
    fontSize: 10,
    lineHeight: '12px',
    textTransform: 'uppercase',
    color: theme.colors.text_secondary
  },
  noPrice: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    whiteSpace: 'nowrap'
  },
  // A real button so keyboard users can reach the tooltip. The theme removes focus outlines
  // globally, so it draws its own.
  helpButton: {
    display: 'inline-flex',
    padding: 0,
    border: 0,
    background: 'none',
    cursor: 'pointer',
    '&:focus-visible': {
      outline: `2px solid ${theme.colorPalette.orange_50}`,
      outlineOffset: 2,
      borderRadius: '50%'
    }
  },
  helpIcon: {
    width: 16,
    height: 16
  },
  rep: {
    whiteSpace: 'nowrap'
  },
  updated: {
    fontSize: 12,
    lineHeight: '16px',
    whiteSpace: 'nowrap'
  }
});

export default makeStyles(styles);
